/** @type {import('../schema').ProcessDefinition} */
const perfilConsentimiento = {
  id: "perfil-consentimiento",
  name: "Perfil y consentimiento",
  category: "personas",
  outcome:
    "El usuario mantiene su perfil; el sistema registra el consentimiento de datos (Ley 18.331).",
  trigger:
    "El usuario abre Mi perfil; o el admin fuerza un reset de contraseña.",
  actors: ["Residente", "Administrador", "Sistema"],
  status: "COMPLETO",
  description:
    "Edición de perfil del usuario con registro append-only de consentimiento, y reset de contraseña forzado por el admin.",
  lanes: [
    { id: "user", actor: "Residente" },
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "user",
      type: "start",
      label: "Edición de perfil",
      description:
        "Nombre, teléfono y foto (con recorte). No cambia email/documento/rol.",
      evidence: "src/screens/MiPerfil.jsx",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "decision",
      label: "¿Datos válidos?",
      description:
        "Valida teléfono y tamaño de foto antes de guardar.",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "document",
      label: "Guardado + consentimiento",
      description:
        "Persiste el perfil (updatedAt) y registra el consentimiento append-only (accept/opt-in/opt-out). Falla de consent no bloquea el guardado.",
      evidence: "functions/identity/cuenta.js (updateMyContact → consent_log)",
    },
    {
      id: "s4",
      laneId: "user",
      type: "end",
      label: "Perfil actualizado",
    },
    {
      id: "s5",
      laneId: "user",
      type: "end",
      label: "Error de validación",
      description:
        "Teléfono inválido o foto demasiado grande: se pide corregir.",
    },
    {
      id: "s6",
      laneId: "admin",
      type: "start",
      label: "Reset de contraseña (admin)",
      description:
        "Al dar de alta un staff o cambiarle el email, se envía el correo para definir la contraseña; el usuario también puede pedirlo con 'Olvidé mi contraseña'.",
      evidence: "src/screens/admin/GestionAdmins.jsx:208 (sendPasswordResetEmail), src/screens/Login.jsx",
    },
    {
      id: "s7",
      laneId: "sys",
      type: "notification",
      label: "Email de reset enviado",
      description:
        "El Sistema envía al usuario el email de reset de contraseña.",
    },
    {
      id: "s8",
      laneId: "sys",
      type: "end",
      label: "Reset entregado",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "Válidos" },
    { from: "s2", to: "s5", label: "Inválidos" },
    { from: "s3", to: "s4" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
  ],
};
export default perfilConsentimiento;
